import tippy from 'tippy.js';

export default class {
  constructor(el) {
    this.el = el;
    document.addEventListener('DOMContentLoaded', () => { this.initialize(); });
  }

  initialize() {
    tippy('.js-tooltip', {
      allowHTML: true,
      placement: 'top',
      theme: 'light-border',
      content(el) {
        if (el.nextElementSibling.type === 'text/x-template') {
          return el.nextElementSibling.innerHTML;
        }
        return '';
      },
    });
  }
}
